import axios from "axios";
import { ActionTypes } from "utils/constants";
import { getEnvVar } from "utils/get-env-var";

export const fetchSales = () => ({
    type: ActionTypes.FETCH_ACTIVE_SALE,
    payload: axios.get(`${getEnvVar('API_BASE')}/active-sales`)
});
